import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoPlano } from "../../../../types";
import BlocoAlteracoes from "../../Compartilhado/Blocos/BlocoAlteracoes";
import { CampoAlteracao } from "../../Compartilhado/Blocos/BlocoAlteracoes";

interface ExpandedContentProps {
  item: IItemHistoricoPlano;
  isExpanded?: boolean;
}

function formatarValor(valor: any, isMonetary: boolean = false): string {
  if (valor === null || valor === undefined) return '—';
  
  // Converter para número se for string
  let valorNumerico: number;
  if (typeof valor === 'string') {
    valorNumerico = parseFloat(valor);
    if (isNaN(valorNumerico)) return String(valor);
  } else if (typeof valor === 'number') {
    valorNumerico = valor;
  } else {
    return String(valor);
  }
  
  // Se for um valor monetário, sempre formatar como R$ com separadores de milhares
  if (isMonetary) {
    // Formatar com 2 casas decimais e separador de milhares
    const valorFormatado = valorNumerico.toFixed(2).replace('.', ',');
    // Adicionar separador de milhares (pontos)
    const partes = valorFormatado.split(',');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${partes.join(',')}`;
  }
  
  return String(valorNumerico);
}

function mapearDadosPlanoEditado(payload: any): CampoAlteracao[] {
  if (!payload || !payload.antes || !payload.depois) return [];

  const campos: CampoAlteracao[] = [];
  const antes = payload.antes;
  const depois = payload.depois;

  if (antes.nome !== depois.nome) {
    campos.push({
      campo: 'Nome',
      antes: formatarValor(antes.nome, false),
      depois: formatarValor(depois.nome, false)
    });
  }
  if (antes.validade_creditos_dias !== depois.validade_creditos_dias) {
    campos.push({
      campo: 'Validade (dias)',
      antes: formatarValor(antes.validade_creditos_dias, false),
      depois: formatarValor(depois.validade_creditos_dias, false)
    });
  }
  if (antes.quantidade_creditos !== depois.quantidade_creditos) {
    campos.push({
      campo: 'Quantidade de Créditos',
      antes: formatarValor(antes.quantidade_creditos, false),
      depois: formatarValor(depois.quantidade_creditos, false)
    });
  }
  // Comparar valor_plano considerando null e undefined como equivalentes
  const valorPlanoAntes = antes.valor_plano ?? null;
  const valorPlanoDepois = depois.valor_plano ?? null;
  if (valorPlanoAntes !== valorPlanoDepois) {
    campos.push({
      campo: 'Valor do Plano',
      antes: formatarValor(valorPlanoAntes, true),
      depois: formatarValor(valorPlanoDepois, true)
    });
  }
  
  // Comparar valor_onboarding considerando null e undefined como equivalentes
  const valorOnboardingAntes = antes.valor_onboarding ?? null;
  const valorOnboardingDepois = depois.valor_onboarding ?? null;
  if (valorOnboardingAntes !== valorOnboardingDepois) {
    campos.push({
      campo: 'Valor Onboarding',
      antes: formatarValor(valorOnboardingAntes, true),
      depois: formatarValor(valorOnboardingDepois, true)
    });
  }
  if (antes.status !== depois.status) {
    campos.push({
      campo: 'Status',
      antes: formatarValor(antes.status, false),
      depois: formatarValor(depois.status, false)
    });
  }

  return campos;
}

export default function ExpandedContentPlanoEditado({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload) : item.payload;
  const campos = mapearDadosPlanoEditado(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhuma alteração detectada.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoAlteracoes campos={campos} />
    </ExpandedContent>
  );
}
